import { Listbox } from "@headlessui/react"
import { ChevronDown } from "lucide-react"
import { twMerge } from "tailwind-merge"

// Deep import, not the ../ui barrel: utils is reachable from redux, and the
// barrel pulls redux back in, closing a utils -> ui -> redux -> utils cycle.
import If from "../ui/if"
import { SelectOption } from "../../types"

export const findSelectedOption = (
  options: { id: string; name: string }[],
  value: string
) => options?.find(opt => opt.id === value)

export const findSelectOptionName = (
  id: string | number,
  options: readonly SelectOption[]
) => options.find(item => item.id === id)?.name

export const findSelectOptionId = (
  name: string,
  options: readonly SelectOption[]
) => {
  return options.find(item => item.name === name)?.id
}

export const getSelectedOptionHTML = (
  selected: any,
  buttonClassName: string,
  multiple?: boolean,
  isLoading?: boolean,
  selectedLabel?: string,
  size: "sm" | "md" = "md",
  isError?: boolean
) => {
  const sizeClasses =
    size === "sm" ? "py-1.5 px-2.5 pr-8 text-xs" : "p-3 pr-10 sm:text-sm"

  return (
    <Listbox.Button
      className={twMerge(
        `relative w-full cursor-pointer rounded-md border ${
          isError ? "border-red-500" : "border-neutral-200"
        } text-left shadow-sm focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400`,
        sizeClasses,
        buttonClassName
      )}
    >
      <span className="block truncate">
        {multiple && (selected?.length ? selected.join(", ") : "-")}{" "}
        {!multiple && (
          <>
            {selected?.icon && (
              <span className="flex items-center">
                <span className="pr-2">{selected.icon}</span>
                <span className="font-medium text-sm md:text-base">
                  {selected.name}
                </span>
              </span>
            )}
            {!selected?.icon && (selectedLabel ?? "-")}
          </>
        )}
      </span>
      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
        <If
          loaderSize={6}
          isLoading={isLoading}
          condition
          then={
            <ChevronDown
              className={`${
                size === "sm" ? "h-4 w-4" : "h-5 w-5"
              } text-gray-400`}
              aria-hidden="true"
            />
          }
        />
      </span>
    </Listbox.Button>
  )
}
